// list of all tracker events
export type MixPanelEventsType = typeof events;

const events = {
  pwaInstallPrompted: 'pwaInstallPrompted',
  pwaInstallResponse: 'pwaInstallResponse',
  pwaInstallAccountWidget: 'pwaInstallAccountWidget',
  pwaInstallBrowserResponse: 'pwaInstallBrowserResponse',
  pwaPushNotificationsPrompted: 'pwaPushNotificationsPrompted',
  pwaPushNotificationsResponse: 'pwaPushNotificationsResponse',
  pwaPushNotificationsBrowserResponse: 'pwaPushNotificationsBrowserResponse',

  accountListArrow: 'accountListArrow',
  accountNameSave: 'accountNameSave',
  active: 'active',
  crash: 'crash',
  darkMode: 'darkMode',
  exception: 'exception',
  alertDialog: 'alertDialog',
  assert: 'assert',
  fiErrorDetailsView: 'fiErrorDetailsView',
  fiLoginFixItFlowStart: 'fiLoginFixItFlowStart',
  fiLoginFixItFlowCancel: 'fiLoginFixItFlowCancel',
  fiLoginNameSave: 'fiLoginNameSave',
  txnManualMatch: 'txnManualMatch',
  txnColumnsSettings: 'txnColumnsSettings',
  txnDelete: 'txnDelete',
  txnOpen: 'txnOpen',
  txnSave: 'txnSave',
  txnPrefs: 'txnPrefs',
  txnEditDetails: 'txnEditDetails',
  accountBalanceChange: 'accountBalanceChange', // TODO: Deprecated? (not used in web, unsure about mobile)
  accountBalanceMismatch: 'accountBalanceMismatch', // TODO: Deprecated? (not used in web, unsure about mobile)
  txnRegActivity: 'txnRegActivity',
  txnReviewMany: 'txnReviewMany',
  reconcileAnAccount: 'reconcileAnAccount', // TODO: Deprecated? (not used in web, unsure about mobile)
  // balance toggle
  viewAccountMenu: 'viewAccountMenu',
  changeAccountSetting: 'changeAccountSetting',

  txnTopMenuToggle: 'txnTopMenuToggle',
  prefScheduleTransactionVisibility: 'prefScheduleTransactionVisibility',
  calendarPrefModalOpen: 'calendarPrefModalOpen',
  calendarPrefResetDefault: 'calendarPrefResetDefault',
  calendarPrefSave: 'calendarPrefSave',
  calendarOnDateChanged: 'calendarOnDateChanged',
  calendarOnTransactionClick: 'calendarOnTransactionClick',
  calendarOnOpenPopover: 'calendarOnOpenPopover',
  calendarTxnModalOpen: 'calendarTxnModalOpen',
  calendarOnGoToBills: 'calendaronGoToBills',
  calendarAccountsPrefsModalOpen: 'calendarAccountsPrefsModalOpen',

  spendingDrillDown: 'spendingDrillDown',
  spendingDateRange: 'spendingDateRange',
  spendingBreadcrumb: 'spendingBreadcrumb',
  spendingChartView: 'spendingChartView',
  spendingPlanClientCalc: 'spendingPlanClientCalc',
  spendingPlanServerCalc: 'spendingPlanServerCalc',
  barSelected: 'barSelected',
  payeeSelected: 'payeeSelected',

  editBudget: 'editBudget',
  budgetView: 'budgetView',
  budgetChange: 'budgetChange',
  connectivity: 'connectivity',
  experiment: 'experiment',

  myAccount: 'myAccount',
  datasetChange: 'datasetChange',
  datasetNameSave: 'datasetNameSave',

  addFIStart: 'addFIStart',
  addFISelect: 'addFISelect',
  addFIAuthenticated: 'addFIAuthenticated',
  addFIComplete: 'addFIComplete',
  viewSecurityMsg: 'viewSecurityMsg',

  addFICancel: 'addFICancel',
  addFIError: 'addFIError',

  fixFIStart: 'fixFIStart',
  fixFISelect: 'fixFISelect',
  fixFIAuthenticated: 'fixFIAuthenticated',
  fixFIComplete: 'fixFIComplete',

  fixFICancel: 'fixFICancel',
  fixFIError: 'fixFIError',

  refreshStart: 'refreshStart',
  refreshPoll: 'refreshPoll',
  refreshSuccess: 'refreshSuccess',
  refreshError: 'refreshError',
  refreshDelay: 'refreshDelay',

  refreshMfaTriggered: 'refreshMfaTriggered',
  refreshMfaCancelled: 'refreshMfaCancelled',
  refreshMfaSubmitted: 'refreshMfaSubmitted',

  watchlistCreate: 'watchlistCreate',
  watchlistEdit: 'watchlistEdit',
  watchlistDelete: 'watchlistDelete',
  watchlistDetailsView: 'watchlistDetailsView',

  nps: 'nps',
  npsStart: 'npsStart',
  npsRequested: 'npsRequested',

  categoryCreate: 'categoryCreate',
  categoryEdit: 'categoryEdit',
  categoryDelete: 'categoryDelete',

  tagCreate: 'tagCreate',
  tagEdit: 'tagEdit',
  tagDelete: 'tagDelete',

  // getting started funnels and flows
  pageView: 'pageView',
  signUp: 'signUp',
  signIn: 'signIn',
  logout: 'logout', // props: description, context
  authWidgetRedirect: 'authWidgetRedirect',

  // simplifi set-up flow
  datasetCreated: 'datasetCreated',
  firstName: 'firstName',
  lastName: 'lastName',
  zipCode: 'zipCode',
  addedNewIncome: 'addedNewIncome',
  addedNewBill: 'addedNewBill',
  confirmedIncome: 'confirmedIncome',
  confirmedBill: 'confirmedBills',
  removedIncome: 'removedIncome',
  removedBill: 'removedBill',
  editModel: 'editModel',
  editModelGSF: 'editModelGSF',
  fisAdded: 'fisAdded',
  completeGettingStarted: 'completeGettingStarted',

  showIntercom: 'showIntercom',

  survey: 'survey', // TODO: temporary hack - we should use MCP instead - remove it

  // Saving Goals
  createGoal: 'createGoal',
  editGoal: 'editGoal',
  takeFrom: 'takeFrom',
  addTo: 'addTo',
  spendingReportSurvey: 'spendingReportSurvey', // { rating: 1-5 }

  // Transition Page events
  transitionPageStart: 'transitionPageStart',
  transitionStartChoice: 'transitionStartChoice',
  transitionDownloadPlatform: 'transitionDownloadPlatform',

  // Webfirst wizard
  wizardWFClose: 'wizardWFClose',
  wizardTopMenuAccounts: 'wizardTopMenuAccounts',
  wizardTopMenuBillscout: 'wizardTopMenuBillscout',
  wizardTopMenuBudgets: 'wizardTopMenuBudgets',

  // Webfirst Billscout
  editedIncome: 'editedIncome',
  skipIncome: 'skipIncome',
  editedBill: 'editedBill',
  skipBill: 'skipBill',
  findFromTransaction: 'findFromTransaction',
  addManually: 'addManually',
  dashboardBillscout: 'dashboardBillscout',
  wizardBillscout: 'wizardBillscout',

  // Webfirst Budget
  openBudgetSuggestion: 'openBudgetSuggestion',
  addedNewBudgetCategory: 'addedNewBudgetCategory',
  editedBudgetAmount: 'editedBudgetAmount',
  removedBudgetCategory: 'removedBudgetCategory',
  dashboardAddBudget: 'dashboardAddBudget',
  wizardAddBudget: 'wizardAddBudget',
  skipBudgetFlow: 'skipBudgetFlow',
  createdBudget: 'createdBudget',
  editedBudget: 'editedBudget',

  // Webfirst accounts
  dashboardAddAccount: 'dashboardAddAccount',
  wizardAddAccount: 'wizardAddAccount',

  // app init
  init: 'init',
  load: 'load',
  persistLoadStart: 'persistLoadStart',
  persistLoadComplete: 'persistLoadComplete',
  persistLoadError: 'persistLoadError',
  persistPurge: 'persistPurge',

  // app intro
  viewIntroAppScreen: 'viewIntroAppScreen',
  viewIntroAsset1: 'viewAsset1',
  viewIntroAsset2: 'viewAsset2',
  viewIntroAsset3: 'viewAsset3',

  // mcp
  memberCommunicationDisplayMessage: 'MemberCommunication:displayMessage',
  memberCommunicationDismissMessage: 'MemberCommunication:dismissMessage',

  // Monthly Summary Rating
  monthlySummary: 'monthlySummary', // { rating: int, feedback: string }

  serviceWorker: 'serviceWorker',
  csvImport: 'csvImport',

  budgetItemCreate: 'budgetItemCreate',
  budgetItemEdit: 'budgetItemEdit',
  budgetItemDelete: 'budgetItemDelete',
  budgetItemReleaseFunds: 'budgetItemReleaseFunds',
  budgetItemDetailsView: 'budgetItemDetailsView',

  webSocket: 'webSocket',

  // Rules
  txnRulesList: 'txnRulesList',
  txnRuleStarted: 'txnRuleStarted',
  txnRuleCompleted: 'txnRuleCompleted',
  txnRuleDuplicate: 'txnRuleDuplicate',
  txnRuleSearch: 'txnRuleSearch',
  txnRuleDeleted: 'txnRuleDeleted',

  // Rules - legacy - remove after rules are fully migrated
  payeeRuleCreate: 'payeeRuleCreate',
  payeeRuleEdit: 'payeeRuleEdit',
  payeeRuleDelete: 'payeeRuleDelete',
  categoryRuleCreate: 'categoryRuleCreate',
  categoryRuleEdit: 'categoryRuleEdit',
  categoryRuleDelete: 'categoryRuleDelete',

  refundCreate: 'refundCreate',
  refundEdit: 'refundEdit',
  refundManualMatch: 'refundManualMatch',
  refundDelete: 'refundDelete',
  refundUnMatch: 'refundUnMatch',

  subscriptionAlertShown: 'subscriptionAlertShown',
  subscriptionAlertCTA: 'subscriptionAlertCTA',
  subscriptionAlertDismissed: 'subscriptionAlertDismissed',

  browserUpdate: 'browserUpdate',

  addBillerStart: 'addBillerStart',
  addBillerSelect: 'addBillerSelect',
  addBillerAuthenticated: 'addBillerAuthenticated',
  addBillerComplete: 'addBillerComplete',
  addBillerCancel: 'addBillerCancel',
  addBillerError: 'addBillerError',

  fixBillerStart: 'fixBillerStart',
  fixBillerError: 'fixBillerError',
  fixBillerComplete: 'fixBillerComplete',
  disconnectBiller: 'disconnectBiller',

  // PWA Subscription tracking
  pickPlan: 'pickPlan',
  subscriptionPayView: 'subscriptionPayView',
  subscriptionPurchaseError: 'subscriptionPurchaseError',
  startTrial: 'startTrial',

  // Setup Checklist
  checklistView: 'checklistView',
  checklistStart: 'checklistStart',
  checklistClick: 'checklistClick',
  checklistItemComplete: 'checklistItemComplete',
  checklistComplete: 'checklistComplete',
  checklistDismiss: 'checklistDismiss',

  // Request FI
  requestFISelected: 'requestFISelected',
  requestFISubmit: 'requestFISubmit',

  feedback: 'feedback',
  authWidget: 'authWidget',

  // achievements
  achievementsPageView: 'achievementsPageView',
  achievementStart: 'achievementStart',
  milestonesEarned: 'milestonesEarned',
  achievementComplete: 'achievementComplete',

  // Lifehub
  qlhGetStartedClicked: 'qlhGetStartedClicked',
  qlhBannerDismissed: 'qlhBannerDismissed',
  qlhLaunchClicked: 'qlhLaunchClicked',

  // A2A
  viewTransfersIntroScreen: 'viewTransfersIntroScreen',

  // User Onboarding
  viewIdentityVerification: 'viewIdentityVerification',
  identitySelectDisclosure: 'identitySelectDisclosure',
  identityFormCancel: 'identityFormCancel',
  identityFormSubmitted: 'identityFormSubmitted',
  identityVerificationResult: 'identityVerificationResult',
  identityVerificationCompleted: 'identityVerificationCompleted',
  identityUnableToComplete: 'identityUnableToComplete',
  identityVerificationError: 'identityVerificationError',
  identityVerificationSubmitted: 'identityVerificationSubmitted',

  // Email Verification
  viewEmailVerification: 'viewEmailVerification',
  verificationEmailSent: 'verificationEmailSent',
  verificationEmailResent: 'verificationEmailResent',
  emailVerified: 'emailVerified',
  verificationEmailError: 'verificationEmailError',

  // Phone Verification
  viewPhoneVerification: 'viewPhoneVerification',
  verificationPhoneSent: 'verificationPhoneSent',
  verificationPhoneResent: 'verificationPhoneResent',
  phoneVerified: 'phoneVerified',

  // Account verification
  viewAccountSetup: 'viewAccountSetup',
  institutionSelect: 'institutionSelect',
  accountSelect: 'accountSelect',
  enterAccountDetails: 'enterAccountDetails',
  routingNumber: 'routingNumber',
  accountNumber: 'accountNumber',
  confirmAccountNumber: 'confirmAccountNumber',
  accountSetupCompleted: 'accountSetupCompleted',
  authorizeTransfer: 'authorizeTransfer',
  viewMicrodeposits: 'viewMicrodeposits',
  accountSetupError: 'accountSetupError',

  // Microdeposit verification (Only used as a backup so as long as the intuit widget holds up we should never get these)
  microdepositSubmit: 'microdepositSubmit',
  microdepositError: 'microdepositError',

  // Transfers
  transferStart: 'transferStart',
  transferSubmit: 'transferSubmit',
  transfersError: 'transferError',

  // Transfer Activity Tracking
  viewTransferActivity: 'viewTransferActivity',
  viewTransferDetails: 'viewTransferDetails',
  cancelTransfer: 'cancelTransfer',

  //  Investments
  investmentsView: 'investmentsView',
  timeSpentOnInvestments: 'timeSpentOnInvestments',
  holdingDetailView: 'holdingDetailView',
  investmentNewsStoryView: 'investmentNewsStoryView',
  investmentsColumnChange: 'investmentsColumnChange',
  changeHolding: 'changeHolding',
  investmentsChartScaleType: 'investmentsChartScaleType',
  investmentsChartType: 'investmentsChartType',

  connection: 'connection', // track online/offline status

  // Spending plan
  hideIgnoredTxns: 'hideIgnoredTxns',
  viewSpendingPlan: 'viewSpendingPlan',
  viewIncomeAfterBills: 'viewIncomeAfterBills',
  viewPlannedSpending: 'viewPlannedSpending',
  viewOtherSpending: 'viewOtherSpending',
  updatePlannedSpendingItemView: 'updatePlannedSpendingItemView',
  rolloversOptIn: 'rolloversOptIn',
  resetRollovers: 'resetRollovers',
  startingRollover: 'startingRollover',
  viewSpendingPlanFutureMonths: 'viewSpendingPlanFutureMonths',
  viewProjectedOtherSpending: 'viewProjectedOtherSpending',
  viewFixItBanner: 'viewFixItBanner',
  dismissFixIt: 'dismissFixIt',
  spendingPlanClosed: 'spendingPlanClosed',
  resolvedSpendingPlan: 'resolvedSpendingPlan',
  editSpendingPlanBucket: 'editSpendingPlanBucket',
  ftsMissedBump: 'ftsMissedBump',
  txnUpdatedInFTSRegister: 'txnUpdatedInFTSRegister',
  goalUpdatedInFTSRegister: 'goalUpdatedInFTSRegister',
  spendingPlanSetupCompleted: 'spendingPlanSetupCompleted',

  // Spending Plan GSF V2
  viewSpendingPlanOnboardingV2: 'viewSpendingPlanOnboardingV2',
  completeSpendingPlanIntro: 'completeSpendingPlanIntro',
  startSPIncomeVerification: 'startSPIncomeVerification',
  verifiedOneTimeIncome: 'verifiedOneTimeIncome',
  completeSPIncomeVerification: 'completeSPIncomeVerification',
  automaticallyIncludeIncome: 'automaticallyIncludeIncome',
  startSPBillsVerification: 'startSPBillsVerification',
  completeSPBillsVerification: 'completeSPBillsVerification',
  viewPlannedSpendIntro: 'viewPlannedSpendIntro',
  selectSuggestedBudget: 'selectSuggestedBudget',
  deleteSuggestedBudget: 'deleteSuggestedBudget',
  addSuggestedBudget: 'addSuggestedBudget',
  addBudgetFromOtherSpend: 'addBudgetFromOtherSpend',
  viewOtherSpendIntro: 'viewOtherSpendIntro',
  completeSpendingPlanSetup: 'completeSpendingPlanSetup',
  viewSavingsGoalSetupBanner: 'viewSavingsGoalSetupBanner',
  viewSpendingPlanTooltips: 'viewSpendingPlanTooltips',
  viewTransfersLearnMore: 'viewTransfersLearnMore',

  // autoRelease
  enableAutoRelease: 'enableAutoRelease',
  disableAutoRelease: 'disableAutoRelease',
  batchReleaseFunds: 'batchReleaseFunds',

  // Add Asset: Zillow
  addAssetsUX_1: 'addAssetsUX_1',
  zillowUX_2: 'zillowUX_2',
  zillowUX_3: 'zillowUX_3',
  zillowUX_4: 'zillowUX_4',
  zillowUX_5: 'zillowUX_5',
  updateHomeValue: 'updateHomeValue',

  // Dataset sharing
  viewSpaces: 'viewSpaces',
  inviteMember: 'inviteMember',
  sharedDatasetAccessed: 'sharedDatasetAccessed',

  addCustomSecurity: 'addCustomSecurity',
  securityPolicyViolation: 'securityPolicyViolation',

  // Custom Freq
  changedFrequency: 'changedFrequency',
  viewFrequencyDetails: 'viewFrequencyDetails',

  // Upcoming
  viewUpcoming: 'viewUpcoming',
  viewCashFlow: 'viewCashFlow',
  viewRefundTracker: 'viewRefundTracker',
  saveDatePreference: 'saveDatePreference',
  viewPastDue: 'viewPastDue',
  sortApplied: 'sortApplied',
  viewRecurring: 'viewRecurring',

  //Launch Darkly Failure
  launchDarkly: 'launchDarkly',

  // QEM events
  qemGsfWelcome: 'qemGsfWelcome',
  qemGsfPrimaryGoals: 'qemGsfPrimaryGoals',
  qemGsfHouseholdName: 'qemGsfHouseholdName',
  qemGsfAddMembers: 'qemGsfAddMembers',
  qemGsfAddCoOwner: 'qemGsfAddCoOwner',
  qemGsfComplete: 'qemGsfComplete',

  qemNewItemFlowStarted: 'qemNewItemFlowStarted',
  qemNewItemFlowSelectItemType: 'qemNewItemFlowSelectItemType',
  qemNewItemFlowCreateItem: 'qemNewItemFlowCreateItem',
  qemNewItemFlowAbandon: 'qemNewItemFlowAbandon',
  qemNewItemFlowSuggestion: 'qemNewItemFlowSuggestion',

  qemGuideNewItemStarted: 'qemGuideNewItemStarted',
  qemGuideConnectQuicken: 'qemGuideConnectQuicken',
  qemGuideDismiss: 'qemGuideDismiss',

  qemFolderAddItem: 'qemFolderAddItem',
  qemFolderAddItemSelected: 'qemFolderAddItemSelected',
  qemFolderRemoveItemSelected: 'qemFolderRemoveItemSelected',
  qemFolderAddItemSearch: 'qemFolderAddItemSearch',
  qemFolderAdditemDismissed: 'qemFolderAdditemDismissed',
  qemFolderAddFromItem: 'qemFolderAddFromItem',

  qemSearch: 'qemSearch',
  qemImageUpload: 'qemImageUpload',
  qemAddItem: 'qemAddItem',

  // QEM - Quicken Integration
  qemCon2PfmStartImport: 'qemCon2PfmStartImport',
  qemCon2PfmDataFile: 'qemCon2PfmDataFile',
  qemCon2PfmAccounts: 'qemCon2PfmAccounts',
  qemCon2PfmProperty: 'qemCon2PfmProperty',
  qemCon2PfmBills: 'qemCon2PfmBills',
  qemCon2PfmSettings: 'qemCon2PfmSettings',
  qemCon2PfmComplete: 'qemCon2PfmComplete',
  qemPfmDisconnectDataFile: 'qemPfmDisconnectDataFile',
  qemPfmDisconnectAcct: 'qemPfmDisconnectAcct',
  qemPfmDisconnectTransaction: 'qemPfmDisconnectTransaction',
  qemPfmConnectAcct: 'qemPfmConnectAcct',
  qemPfmConnTransaction: 'qemPfmConnTransaction',
  qemPfmFieldSourceChange: 'qemPfmFieldSourceChange',
  qemPfmSettings: 'qemPfmSettings',

  // Transactions On Demand
  transactionsOnDemand: 'transactionsOnDemand',

  // Splits V2
  viewSplitsV2: 'viewSplitsV2',
  splitsV2Action: 'splitsV2Action',
  saveSplitsV2: 'saveSplitsV2',
  splitsV2ShowMore: 'splitsV2ShowMore',

  // Credit Score
  creditScoreEntry: 'creditScoreEntry',
  creditScoreReg: 'creditScoreReg',
  creditScoreReport: 'creditScoreReport',

  // Scheduled Transactions
  createSeries: 'createSeries',
  editSeries: 'editSeries',
  changeSeries: 'changeSeries',
  deleteReminder: 'deleteReminder',
  linkReminderToTxn: 'linkReminderToTxn',
  excludeFromSpendingPlan: 'excludeFromSpendingPlan',
  excludeFromReports: 'excludeFromReports',
  changeReminder: 'changeReminder',
  reminderExcludeFromSpendingPlan: 'reminderExcludeFromSpendingPlan',
  reminderExcludeFromReports: 'reminderExcludeFromReports',

  // Fi Issue Banner
  fiStatusBanner: 'fiStatusBanner',

  // Net Income - Reports
  viewedReports: 'viewedReports',
  expandedCategory: 'expandedCategory',
  collapsedCategory: 'collapsedCategory',
  drilledIntoCategory: 'drilledIntoCategory',
  exportReport: 'exportReport',
  changeGridDisplayOption: 'changeGridDisplayOption',

  // Report Filters
  filteredUsageType: 'filteredUsageType',
  filterViewBy: 'filterViewBy',
  filterIntervals: 'filterIntervals',
  filterBreakdownBy: 'filterBreakdownBy',
  filterSet: 'filterSet',

  // Retirement Planner
  viewRetirementPlanner: 'viewRetirementPlanner',
  editRetirementPlanner: 'editRetirementPlanner',
  resetToDefault: 'resetToDefault',
  retirementBannerDismiss: 'retirementBannerDismiss',

  barchartPeriod: 'barchartPeriod',

  // QBP
  createInvoiceStart: 'createInvoiceStart',
  createInvoiceSaved: 'createInvoiceSaved',
  editInvoiceSaved: 'editInvoiceSaved',
  previewInvoice: 'previewInvoice',
  sendInvoiceStart: 'sendInvoiceStart',
  sendInvoiceFinished: 'sendInvoiceFinished',
  viewInvoiceDashboard: 'viewInvoiceDashboard',
  editClient: 'editClient',
  addGlobalItem: 'addGlobalItem',
  createProjectStart: 'createProjectStart',
  editProject: 'editProject',
  createProjectSaved: 'createProjectSaved',
  projectCompleted: 'projectCompleted',
  viewProjectDetails: 'viewProjectDetails',
  projectAddProductService: 'projectAddProductService',
  projectEditProductService: 'projectEditProductService',
  projectAddExpense: 'projectAddExpense',
  filterItemStatus: 'filterItemStatus',
  createClientStart: 'createClientStart',
  createClientSaved: 'createClientSaved',
  viewedClientDashboard: 'viewedClientDashboard',
  viewedClientDetails: 'viewedClientDetails',
  sortedClientList: 'sortedClientList',
  filterTopRevenue: 'filterTopRevenue',
  filterBusiness: 'filterBusiness',
  filteredHeaderBoxes: 'filteredHeaderBoxes',
  tappedSeeAll: 'tappedSeeAll',
  emailClient: 'emailClient',
  expandedSchedule: 'expandedSchedule',
  collapsedSchedule: 'collapsedSchedule',
  downloadReport: 'downloadReport',
  printReport: 'printReport',
  enabledGridDisplayOption: 'enabledGridDisplayOption',
  disabledGridDisplayOption: 'disabledGridDisplayOption',
  addBusinessStart: 'addBusinessStart',
  addBusinessSaved: 'addBusinessSaved',
  addBusinessComplete: 'addBusinessComplete',
  updatedTaxGroup: 'updatedTaxGroup',

  // GSF QBP
  greetingQBP: 'greetingQBP',
  nameZipQBP: 'nameZipQBP',
  businessEntryQBP: 'businessEntryQBP',
  businessListQBP: 'businessListQBP',
  FILauncherQBP: 'FILauncherQBP',
  billScoutWaiterQBP: 'billScoutWaiterQBP',
  incomeQBP: 'incomeQBP',
  billsQBP: 'billsQBP',
  finalRedirectQBP: 'finalRedirectQBP',

  // QBP : Stripe enable flow events
  enableStripeLearnMore: 'enableStripeLearnMore',
  stripeConnectFlowStart: 'stripeConnectFlowStart',
  stripeConnectFlowComplete: 'stripeConnectFlowComplete',

  // QBP : Payment events
  stripeInvoicePayment: 'stripeInvoicePayment', // paying an invoice through Stripe
  failedInvoicePayment: 'failedInvoicePayment', // failed payment through Stripe
  invoicePayment: 'invoicePayment', // Non Stripe invoice payments
  creditGenerated: 'creditGenerated', // For Overpayment

  // QBP: Account Bar Reorder
  reorderAccountGroups: 'reorderAccountGroups',
  shownAccountGroupInsert: 'shownAccountGroupInsert',
  dismissedAccountGroupInsert: 'dismissedAccountGroupInsert',
  tapped3DotMenu: 'tapped3DotMenu',

  // GSF
  greeting: 'greeting',
  nameZip: 'nameZip',
  FILauncher: 'FILauncher',
  billScoutWaiter: 'billScoutWaiter',
  income: 'income',
  bills: 'bills',
  finalRedirect: 'finalRedirect',

  billScout: 'billScout',
  logoTicker: 'logoTicker',
  txnSwipeAction: 'txnSwipeAction',
};

export default events;
